<div class="top-wrapper">
  <img class="topbar-logo" src="assets/kmt_logo.svg" alt="Kuhnert Messtechnik" />
  <div class="flex flex-row items-center gap-3">
    <span class="topbar-user">
      {{ portal.contact()?.name ?? portal.contact()?.email ?? keycloak.userProfile()?.email }}
    </span>
    <p-button
      icon="pi pi-sign-out"
      label="Logout"
      [text]="true"
      severity="secondary"
      size="small"
      (onClick)="keycloak.logout()"
    />
  </div>
</div>
